import React from 'react';
import styled from 'styled-components';
import Svg from '_assets/svg';

const Img = styled.img`
    width: 8px;
    height: 8px;
    ${props => props.down && `
        -webkit-transform: rotate(-180deg);
        -moz-transform: rotate(-180deg);
        -ms-transform: rotate(-180deg);
        -o-transform: rotate(-180deg);
    `}
`;

const Sort = () => {
    return (
        <div className="d-flex flex-column margin-left-8">
            <Img src={Svg.dropdown.default} />
            <Img src={Svg.dropdown.default} down />
        </div>
    )
}

export default Sort;
